<div class="quote-product-price">
  <span *ngIf="hasProductPrice; else onRequestPrice">
    {{ productPrice }}
  </span>
</div>

<ng-template #onRequestPrice>
  <span i18n>On request</span>
</ng-template>
